import {SingletonService} from '@/common/dependency.configs.ts'
import {inject, injectable} from 'inversify'
import HttpHandler from '@/common/services/connect/HttpHandler.ts'

@SingletonService
@injectable()
export class InstitutionListService {
  constructor(@inject(HttpHandler) private httpHandler: HttpHandler) {}

  getAll(userId: string): Promise<{data: {institutions: Array<IInstitution>}}> {
    return this.httpHandler.get(
      `/openanywhere/banno/v0/users/${userId}/institutions`
    )
  }
}

export interface IInstitution {
  institutionId: string
  name: string
  url: string
}
